import { useNavigate } from 'routes';
import { Button } from 'components/mui';
import { WestIcon } from 'components/icons';
import styles from './PageNotFound.module.css';

function PageNotFound() {
	const navigate = useNavigate();

	const onClick = () => {
		return navigate('/');
	};

	return (
		<section className={styles.main}>
			<section className={styles.section}>
				<h1>404 - PAGE NOT FOUND</h1>
				<hr className={styles.hr} />
				<p>
					The page you are looking for might have been removed had its name changed or is
					temporarily unavailable.
				</p>
				<hr className={styles.hr} />
				<h3>Here is a button that you can go to the HOME page:</h3>
				<Button variant="outlined" startIcon={<WestIcon />} onClick={onClick}>
					GO BACK TO HOME
				</Button>
			</section>
		</section>
	);
}

export default PageNotFound;
